import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPlugin1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPlugin1"><Path d="M10 2H8V6H4V14C4 16.7614 6.23858 19 9 19H11V22H13V19H15C17.7614 19 20 16.7614 20 14V6H16V2H14V6H10V2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPlugin1;
